module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/general-transaction/pigmyremittance-grid/pigmyremittance-grid.component.css
// module id = ./src/app/general-transaction/pigmyremittance-grid/pigmyremittance-grid.component.css
// module chunks = main